<template>
  <div class="goal-preview__container">
    <p><b>{{ title }} </b></p>
    <div class="goal-preview__text">
      {{ text }}
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'GoalsManager',
  components: {
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
  },
};
</script>
  
<style scoped>
.goal-preview__container {
  padding: 20px;
  margin: 20px 0;
  border-radius: 7px;
  background-color: #e2ebe7;
}

.goal-preview__text {
  padding: 15px;
  font-weight: bold;
  border-radius: 5px;
  background-color: white;
}
</style>
  